export default __webpack_public_path__ + "static/media/white_rook.d18260f9.png";